
<template>
  <span>{{account.name}}
    <span style="text-transform:capitalize;word-break: break-word;">({{account.type}})
      <v-icon :color="account.confirmed ? 'success' : 'warning'">{{account.confirmed ? 'mdi-check-circle-outline' : 'mdi-timer-sand-empty'}}</v-icon>
    </span>
    <span class="caption" style="display:block;">{{account.owner}}</span>
  </span>
</template>

<script>
export default {
  components: {},
  name: "AccountWidget",
  mixins: [],
  props: {
    account: {
      type: Object,
      required: true,
    },
  },
};
</script>